import React, { createContext, useContext, useState } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext(null);

// Backend rol numaraları
export const ROLE_IDS = { NORMAL: 1, VIP: 2, SHOP: 3, MODERATOR: 4, ADMIN: 5 };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('Biet Es Runter_user');
    return saved ? JSON.parse(saved) : null;
  });

  const normalize = (data) => ({
    ...data,
    name: data.userNameSurname || data.name || '',
  });

  const login = async (email, password) => {
    const raw  = await authService.login(email, password);
    const data = normalize(raw);
    setUser(data);
    localStorage.setItem('Biet Es Runter_user', JSON.stringify(data));
    return data;
  };

  const register = async (payload) => {
    const raw  = await authService.register(payload);
    const data = normalize(raw);
    setUser(data);
    localStorage.setItem('Biet Es Runter_user', JSON.stringify(data));
    return data;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('Biet Es Runter_user');
  };

  const role = user?.role;
  const isAdmin      = role === ROLE_IDS.ADMIN;
  const isModerator  = role === ROLE_IDS.MODERATOR || isAdmin;
  const isShop       = role === ROLE_IDS.SHOP || isAdmin;
  const isVIP        = role === ROLE_IDS.VIP || isShop;

  return (
    <AuthContext.Provider value={{ user, login, register, logout, isAdmin, isModerator, isVIP, isShop, ROLE_IDS }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
